module.exports = __webpack_public_path__ + "static/media/anuncio1.cfbe2c03.png";